(function () {
  function getPreviewMode() {
    var value = new URLSearchParams(location.search).get('app-banner-preview');
    if (!value) return null;
    if (value === '1' || value === 'true') return 'ios';
    if (value === 'ios' || value === 'android') return value;
    return null;
  }

  function detectMobileStorePlatform() {
    var ua = navigator.userAgent;
    var isIos =
      /iPad|iPhone|iPod/.test(ua) ||
      (ua.indexOf('Mac') !== -1 && 'ontouchend' in document);
    if (isIos) return 'ios';
    if (/Android/i.test(ua)) return 'android';
    return null;
  }

  function getStoreUrl(platform) {
    return platform === 'ios'
      ? 'https://apps.apple.com/app/apple-store/id6772993723?pt=128933811&ct=top_banner_download_ios_app&mt=8'
      : 'https://play.google.com/store/apps/details?id=com.dkhoun.app';
  }

  function shouldShow(preview) {
    if (preview) return true;
    if (window.mobileAppBannerEnabled === false) return false;
    if (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) {
      return false;
    }
    return detectMobileStorePlatform() !== null;
  }

  function init() {
    if (window.Shopify && Shopify.designMode) return;

    var banner = document.getElementById('mobile-app-banner');
    var cta = document.getElementById('mobile-app-banner-cta');
    if (!banner || !cta) return;

    var preview = getPreviewMode();
    if (!shouldShow(preview)) return;

    var platform = preview || detectMobileStorePlatform() || 'ios';
    cta.href = getStoreUrl(platform);

    banner.hidden = false;
    if (preview) banner.classList.add('mobile-app-banner--preview');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
